<template>
  <el-container>
    <el-main class="certificate">
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="clist">
              <div class="item-bar">
                <img src="../assets/img/icon-bar-gray.png" style="width: 100%; height: 50px;" />
                <div class="main">
                  <el-image
                    class="main-img"
                    :src="require('@/assets/img/icon-bar-point.png')"
                  ></el-image>
                  <div class="main-title">{{barTitle}}</div>
                </div>
              </div>
              <div class="clist-card">
                <el-card class="box-card">
                  <div slot="header" class="clearfix" style="margin-bottom: 20px;">
                    <div style="float: left;">
                      <svg t="1621581570186" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1432"  width="20" height="20"><path d="M800.512 474.944h-377.6a24.256 24.256 0 0 0-24.32 24.32c0 13.504 10.816 24.32 24.32 24.32h377.6c13.504 0 24.32-10.816 24.32-24.32a24.576 24.576 0 0 0-24.32-24.32z m-377.6 203.776a24.256 24.256 0 0 0-24.32 24.32c0 13.504 10.816 24.32 24.32 24.32h377.6c13.504 0 24.32-10.816 24.32-24.32a24.576 24.576 0 0 0-24.32-24.32h-377.6z" p-id="1433"></path><path d="M928.064 209.6h-252.736l-5.376-15.68c-37.824-104.832-110.272-129.728-164.288-132.416h-409.728a62.592 62.592 0 0 0-62.72 62.144v776.704c0 34.048 28.096 62.144 62.72 62.144h832.128a62.72 62.72 0 0 0 62.72-62.144v-628.608a62.272 62.272 0 0 0-62.72-62.144z m-848.384-56.256c0-48.128 17.856-41.6 90.816-41.6h261.056c110.784 0 139.456 23.808 160.512 61.056l15.68 36.736h-528.064v-56.192z m773.248 759.424H170.496c-74.56 0-86.464-5.952-86.464-85.952v-566.464h784.576c78.912 0 70.784 30.784 70.784 85.952v492.928c0.064 72.448-25.344 73.536-86.464 73.536z" p-id="1434"></path><path d="M196.992 536.576h78.912v-78.912h-78.912v78.912z m0 205.952h78.912v-78.912h-78.912v78.912z" p-id="1435"></path></svg>
                    </div>
                    <div style="float: left;margin-left: 5px;">
                      <span class="card-header">查询条件</span>
                    </div>

                    <el-tooltip class="item" effect="dark" content="请输入查询条件，进行查询" placement="left">
                      <el-button style="float: right; padding: 3px 0" type="text"><i class="el-icon-question" style="font-size: 18px;"></i>&nbsp;&nbsp;
                        查询说明</el-button>
                    </el-tooltip>
                  </div>
                  <el-form :model="query" :inline="true" @keyup.enter.native="getDataList()">
                    <el-form-item>
                      <el-row>
                        <el-col :span="6">
                          <el-form-item>
                            <el-input v-model="query.userName" placeholder="姓名 (模糊查询)" clearable size="medium"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item>
                            <el-input v-model="query.idNo" placeholder="身份证 (精确查询)" clearable size="medium"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item>
                            <el-input v-model="query.unitName" placeholder="单位 (模糊查询)" clearable size="medium"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item>
                            <el-input v-model="query.certificateCode" placeholder="证书编号 (精确查询)" clearable size="medium"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <el-col :span="24" style="text-align: right;margin-top: -60px;">
                      <el-form-item>
                        <el-row>
                          <el-button @click="clearInput()" >清空</el-button>
                          <el-button @click="getDataList()" class="list-button">查询</el-button>
                        </el-row>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </el-card>
                <el-table
                  :data="certificatList"
                  border
                  @selection-change="handleSelectionChange"
                  style="width: 100%;" :header-cell-style="{backgroundColor:'#3AB14D', color: '#fff'}">
                  <el-table-column
                    prop="userName"
                    align="center"
                    min-width=""
                    label="姓名" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="idNo"
                    align="center"
                    min-width="150"
                    label="身份证号"
                    :formatter="formatter_idNo">
                  </el-table-column>
                  <el-table-column
                    prop="unitName"
                    align="center"
                    label="单位名称"
                    min-width="180" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="certificateCode" align="center" label="证书编号" min-width="180">
                  </el-table-column>
                  <el-table-column prop="validDate" align="center" label="有效期" min-width="100">
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    min-width="50"-->
<!--                    align="center"-->
<!--                    label="操作"-->
<!--                  >-->
<!--                    <template slot-scope="scope">-->
<!--                      <el-button-->
<!--                        size="small"-->
<!--                        type="primary"-->
<!--                        class="buttonList"-->
<!--                        @click="certificateView(scope.row)">查看证书</el-button>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                </el-table>
                <el-pagination
                  background
                  @size-change="sizeChangeHandle"
                  @current-change="currentChangeHandle"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  :total="totalCount"
                  layout="total, prev, pager, next, jumper">
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
      <!--顶部样式-->
      <div class="footer-top">
        <img
          src="@/assets/img/icon-blogroll-title.png"
          height="68"
          width="71"
          style="margin-left: 30px"
        />
        <img
          src="@/assets/img/icon-blogroll1.png"
          height="80"
          width="278"
          style="margin-left: 30px"
          @click="handleCaiZhengTingEvent"
        />
        <img
          src="@/assets/img/icon-blogroll3.png"
          height="80"
          width="278"
          style="margin-left: 30px"
          @click="handleCaiGouWangEvent"
        />
        <img
          src="@/assets/img/icon-blogroll2.png"
          height="80"
          width="278"
          style="margin-left: 30px"
          @click="handleFuWuPingTaiEvent"
        />
      </div>
    </el-main>
  </el-container>

</template>

<script>
import * as dayjs from 'dayjs';
import banner from '@/assets/img/icon-banner.png';
import tp1 from '@/assets/img/tp1.jpg';
import tp2 from '@/assets/img/tp2.jpg';
import tp3 from '@/assets/img/tp3.jpg';
import tp4 from '@/assets/img/tp4.jpg';
import zs from '@/assets/img/zs2.png';
import HeaderBar from '@/components/HeaderBar.vue';
import RedHeaderBar from '@/components/RedHeaderBar.vue';
import { prefixedUrlAsset } from '@/utils/constants';
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'Home',
  components: { HeaderBar, RedHeaderBar, vueSeamlessScroll },
  computed: {
    classOption () {
      return {
        step: 0.6, // 数值越大速度滚动越快
        limitMoveNum: 7, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)

      }
    },
    widthData() {
      return 230 * Number(this.showMembers.length);
    },
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 5,
      };
    }
  },
  data() {
    return {
      banners: [banner],
      //banners2: [tp1,tp2,tp3,tp4],
      banners2: [],
      tableData: [],
      associationDynamics: [], // 协会动态
      notifications: [], // 通知公告
      policiesRegulations: [], // 政策法规
      partyBuildings: [], // 党建园地
      integritySelfDisciplines: [], // 诚信自律
      aboutUsInfos: [], // 协会概况
      downloadItems: [], // 下载中心
      showMembers: [], // 会员风采
      dialog_info_Visible: true,
      zs: [zs],
      barTitle: '证书查询',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      certificatList: [],
      query: {
        userName: '',
        idNo: '',
        unitName: '',
        certificateCode: '',
      },
    };
  },
  watch: {
    $route(newUrl, oldUrl) {
      console.log(newUrl, oldUrl);
    },
  },
  created() {
    console.log(prefixedUrlAsset);
    this.axios.get(`${prefixedUrlAsset}/pub/news/list?pageNo=0&pageSize=10`).then((response) => {
      console.log(response.data);
      if (response.data.data) {
        console.log("获取页面数据");
        console.log(response.data.data);
        // eslint-disable-next-line array-callback-return
        response.data.data.map((item) => {
          if (item.catalog.name === '协会动态') {
            // eslint-disable-next-line no-shadow
            this.associationDynamics = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              type: '【新闻】',
              id: item.id,
            }));
          }
          if (item.catalog.name === '通知公告') {
            // eslint-disable-next-line no-shadow
            this.notifications = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              id: item.id,
            }));
          }
          if (item.catalog.name === '政策法规') {
            // eslint-disable-next-line no-shadow
            this.policiesRegulations = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              id: item.id,
            }));
          }
          if (item.catalog.name === '党建园地') {
            // eslint-disable-next-line no-shadow
            this.partyBuildings = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              id: item.id,
            }));
          }
          if (item.catalog.name === '诚信自律') {
            // eslint-disable-next-line no-shadow
            this.integritySelfDisciplines = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              id: item.id,
            }));
          }
          if (item.catalog.name === '加入协会') {
            // eslint-disable-next-line no-shadow
            this.aboutUsInfos = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              id: item.id,
            }));
          }
          if (item.catalog.name === '下载中心') {
            // eslint-disable-next-line no-shadow
            this.downloadItems = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              id: item.id,
            }));
          }
          if (item.catalog.name === '会员风采') {
            // eslint-disable-next-line no-shadow
            this.showMembers = item.newsList.map((item) => ({
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
              title: item.title,
              id: item.id,
              picUrl: item.picUrl
            }));
          }
        });
      }
    });
    //获取图片新闻列表
    this.axios.get(`${prefixedUrlAsset}/pub/news/picnews/list?pageNo=0&pageSize=4`).then((response) => {
      console.log(response.data);
      if (response.data.data) {
        console.log("获取图片新闻数据");
        console.log(response.data.data);
        this.banners2 = response.data.data;
      }
    });
    //this.getDataList();

  },
  methods: {
    formatter_idNo(row, column, cellValue, index) {
      if (cellValue && cellValue.length >= 8) {
        let b = cellValue.substring(0, 4);
        let e = cellValue.substring(cellValue.length - 4, cellValue.length);
        return b + "***********" + e;
      }
      return cellValue;
    },
    associationDynamicsCellStyle(row) {
      if (row.columnIndex === 0) {
        return 'padding: 0px; font-size:14px; height: 32px; border: none; color: #3F865A; cursor: pointer;';
      }
      return 'padding: 0px; font-size:14px; height: 32px; border: none; cursor: pointer;';
    },
    cellStyle() {
      return 'padding: 0px; font-size:14px; height: 32px; border: none; cursor: pointer;';
    },
    rowStyle() {
      return 'white-space: nowrap;';
    },
    handleAssociationDynamicsEvent(row) { //协会动态
      console.log(row);
      // this.$router.push(`/detail/${row.id}`);
      var id = row.id;
      window.open(`/#/detail/`+id);
    },
    handleNotificationsEvent(row) {//通知公告
      console.log(row);
       // this.$router.push(`/detail/${row.id}`);
      var id = row.id;
      window.open(`/#/detail/`+id);
    },
    handlePoliciesRegulationsEvent(row) { //下载中心 || 政策法规
    // this.$router.push(`/detail/${row.id}`);
      var id = row.id;
      window.open(`/#/detail/`+id);
    },
    handlePartyBuildingsEvent(row) {//党建园地
      var id = row.id;
      window.open(`/#/detail/`+id);

      // this.$router.push(`/detail/${row.id}`);
    },
    handleIntegritySelfDisciplinesEvent(row) {//诚信自律
      var id = row.id;
      window.open(`/#/detail/`+id);
      // this.$router.push(`/detail/${row.id}`);
    },
    handleAboutUsInfosEvent(row) {//协会概况
      // this.$router.push(`/detail/${row.id}`);
      var id = row.id;
      window.open(`/#/detail/`+id);
    },
    handleNormalLoginEvent() {
      window.location.href = './gpassoc-user/#/login';
    },
    handleAdminLoginEvent() {
      window.location.href = './gpassoc-admin/#/login';
    },
    handleCaiZhengTingEvent() {
      window.open('http://czt.ln.gov.cn');
    },
    handleCaiGouWangEvent() {
      window.open('http://www.ccgp-liaoning.gov.cn');
    },
    handleFuWuPingTaiEvent() {
      window.open('http://218.60.145.55/login.do?method=beginlogin&redirectURL=login.do!!@@method@@governmentBuy');
    },
    clickProps(e) {
      console.log(e.target);
      let index = e.target.id;
      if(index){
        window.open(`/#/detail/`+index);
      }
    },
    getDataList() {
      // 获取列表信息
      const that = this;
      if (that.query.userName.trim() === '' && that.query.idNo.trim() === '' && that.query.unitName.trim() === '' && that.query.certificateCode.trim() === '') {

        that.$message({
          type: 'success',
          message: ' 请输入查询条件，进行查询！'
        });
      } else {
        that.axios.post(`${prefixedUrlAsset}/pub/train/cert/search/list`, {
          pageNo: that.currentPage - 1,
          pageSize: that.pageSize,
          userName: that.query.userName,
          idNo: that.query.idNo,
          unitName: that.query.unitName,
          certificateCode: that.query.certificateCode
        }).then((response) => {
          if (response.data.code === 0) {
            that.certificatList = response.data.data.content;
            that.totalCount = response.data.data.totalElements
          }
        })
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //设置表格复选框禁用
    checkboxT(row,index){
      if(row.status !== 0){
        return false;
      }else{
        return true;
      }
    },
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDataList()
    },
    // 当前页:
    currentChangeHandle (val) {
      this.currentPage = val
      this.getDataList()
    },
    clearInput(){
      this.query = this.$options.data().query;
    }
  },
};
</script>

<style lang="scss" scoped="scoped">
  .certificate{
    padding: 0;
    margin-top: 5px;
  }
  .clist{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    padding: 10px 10px 0px 10px;
    margin-bottom: 20px;
  }
  .clist .clist-card{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: white;
    border-left: 1px solid #DCDCDC;
    border-right: 1px solid #DCDCDC;
    border-bottom: 1px solid #DCDCDC;
    box-sizing: border-box;
    border-radius: 0 0 15px 15px;
  }
  /*.clist .clist-card ::v-deep .el-pagination {*/
  /*  text-align: right;*/
  /*}*/
  .clist .clist-card ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    /*进行修改背景和字体*/
    background-color: #3AB14D;
    color: #fff;
  }
  .list-button{
    background: #3AB14D;
    color: white;
  }
  .clist .clist-card ::v-deep .list-button:hover{
    background: #DCDCDC;
    color: #026D31;
  }
  .clist .clist-card ::v-deep .card-header{
    font-weight: 900;
    font-size: 16px;
    color: #3AB14D;
  }
  .clist .clist-card ::v-deep .card-header-right  .card-header{
    font-weight: 900;
    font-size: 16px;
    color: #3AB14D;
    float: right;
  }

</style>
